// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__-GjUy","BtnOk":"Modal_BtnOk__2AjyH","BtnReload":"Modal_BtnReload__2Tu8r"};